import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

export interface Option {
  value: any;
  label?: string;
  labelKey?: string;
}

@Component({
  selector: 'app-data-filter-autocomplete',
  templateUrl: './data-filter-autocomplete.component.html',
  styleUrls: ['./data-filter-autocomplete.component.scss'],
})
export class DataFilterAutocompleteComponent implements OnInit, OnChanges {

  @Input()
  labelKey: string;

  @Input()
  name: string;

  @Input()
  model: string | Option | Array<string | Option> = [];

  @Input()
  options: Option[] = [];

  @Input()
  multiple = false;

  @Input()
  required = false;

  @Input()
  placeholderKey: string;

  @Input()
  notFoundTextKey: string;

  @Input()
  disabled = false;

  @Input()
  valueExtractor: (model: string | Option) => string | Option = m => m;

  @Input()
  useOptionValueExtractor = false;

  @Input()
  addTagText = 'selects.add-item';

  @Input()
  addTagPromise = (name: string) => new Promise((resolve) => resolve(name));

  optionValueExtractor = (m: Option) => m.value;

  @Output()
  modelChange = new EventEmitter<string | Option | Array<string | Option>>();

  constructor(private translation: TranslateService) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled && this.disabled) {
      this.model = undefined;
      this.change();
    }
  }

  change() {
    if (this.model) {
      this.modelChange.emit(this.extractValue(this.model));
    } else {
      this.modelChange.emit(this.model);
    }
  }

  extractValue(model: Array<string | Option> | string | Option): string | Option | Array<string | Option> {
    const valueExtractor: (model: string | Option) => string | Option = this.useOptionValueExtractor ? this.optionValueExtractor : this.valueExtractor;

    if (Array.isArray(model)) {
      return model.map(m => valueExtractor(m));
    } else {
      return valueExtractor(model);
    }
  }
}

